import React from 'react';
import { formatCurrencyPaise, fullCurrency } from '../../../utils/formatCurrency.js';


function AmountCard({ label, amount, icon, color, hint, subAmount, subLabel, subClassName, subAmount2, subLabel2, onClick }) {
  const clickable = typeof onClick === 'function';
  return (
    <div
      className={`bg-white rounded-xl shadow-sm border border-gray-100 p-2.5 sm:p-4 hover:shadow-md transition-shadow relative min-h-[76px] sm:min-h-[90px] min-w-0 h-full pr-9 sm:pr-14 ${
        clickable ? 'cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500' : ''
      }`}
      onClick={clickable ? onClick : undefined}
      onKeyDown={clickable ? (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(e);
        }
      } : undefined}
      role={clickable ? 'button' : undefined}
      tabIndex={clickable ? 0 : undefined}
    >
      <p className="text-gray-500 text-[11px] sm:text-sm font-medium leading-snug break-words pr-1">{label}</p>
      {hint ? (
        <p className="text-[10px] sm:text-[11px] text-gray-400 mt-0.5 leading-snug">{hint}</p>
      ) : null}
      <p className="text-sm sm:text-lg xl:text-xl font-bold text-gray-900 mt-1 break-words" title={fullCurrency(amount)}>
        {formatCurrencyPaise(amount)}
      </p>
      {subLabel && subAmount !== undefined && (
        <p className={`text-[11px] sm:text-sm mt-0.5 sm:mt-1 font-medium break-words ${subClassName || 'text-green-600'}`} title={fullCurrency(subAmount)}>
          {subLabel}: {formatCurrencyPaise(subAmount)}
        </p>
      )}
      {subLabel2 && subAmount2 !== undefined && (
        <p className="text-[11px] sm:text-sm text-orange-600 mt-0.5 font-medium break-words" title={fullCurrency(subAmount2)}>
          {subLabel2}: {formatCurrencyPaise(subAmount2)}
        </p>
      )}
      <div className={`p-1.5 sm:p-2 absolute rounded-lg right-2 bottom-2 sm:right-3 sm:bottom-3 ${color}`}>
        {icon}
      </div>
    </div>
  );
}

export default AmountCard;
